import { Box, CircularProgress } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useStateValue } from '../../providers/StateProvider';
import { bootstrapUserSession, clearStorage, loginRedirectPrivider } from '../../services/auth';
import { actionTypes } from '../../store/reducer';

export default function InitPage(): JSX.Element {
  const history = useHistory();
  const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    const initSession = async () => {
      const token: string | null = localStorage.getItem('gov_access_token');

      if (!token) {
        clearStorage();
        dispatch({
          type: actionTypes.SET_USER,
          user: null,
        });
        loginRedirectPrivider(window.location.pathname);
        return;
      }

      const sessionValid = await bootstrapUserSession(dispatch);
      if (!sessionValid) {
        dispatch({
          type: actionTypes.SET_USER,
          user: null,
        });
        loginRedirectPrivider(window.location.pathname);
      }
    };

    initSession();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (user) {
      const pathname = localStorage.getItem('pathname_redirect_gov');
      const spathname = pathname === '/' ? '/home' : pathname;
      history.push(spathname || '/home');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <Box
      height="100hv"
      width="100hv"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress color="secondary" />
    </Box>
  );
}
